/* eslint-disable comma-dangle */

export default {
    address: [
    'user-input',
    'jk',
        'map',
        'highway',
        'underground'
    ],
    'about-object': [
        'common/cadastral-number',
        'common/tax-number',
        'commercial-multi-area',
        'floor-commercial',
        'ceiling-height',
        'condition-type',
        'specialty-required',
        'common/input-type',
        'has-shop-windows',
        'is-legal-address-provided',
        'common/water-pipes',
        'electricity-power',
        'is-occupied',
        'available-from',
    ],
    'about-building': [
        'name-and-year-commercial-autocomplete-no',
        'building-type',
        'total-area',
        'land',
        {
          name: 'visual-divider',
          hideOnMobile: true,
        },
        'building-status-type',
        'building-developer',
        'building-management-company',
        'additional-items'
    ],
    'price-and-deal-terms': [
        'price-multi-sale',
        'vat-type',
        'lease-assignment-checkbox',
        'agent-bonus'
    ]
};
